"use strict";
// Class definition

var KTDatatableColumnRenderingDemo = function() {
	// Private functions

	// basic demo
	var demo = function() {

        var dataArrayToString= JSON.stringify(ConfData);
        var dataJason = JSON.parse(dataArrayToString);  // convert string to json object
		var datatable = $('#kt_datatable').KTDatatable({
			// datasource definition
			data: {
				type: 'local',
				source: dataJason,
				// source: {
				// 	read: {
				// 		// url: 'https://ddnguyen.org/default.php',
				// 		// url: 'papers/datatables/papers.php',
				// 		// url: 'http://localhost:3000/dist/papers/datatables/papers.php',
				// 		// url: 'https://preview.keenthemes.com/metronic/theme/html/tools/preview//api/?file=datatables/datasource/default.json',
				// 		// url: 'https://preview.keenthemes.com/metronic/theme/html/tools/preview//api/datatables/datasource/default.json',
				// 		url: 'https://preview.keenthemes.com/metronic/theme/html/tools//preview/api/datatables/demos/default.php'

				// 	},
				// 	// contentType: 'application/json',

				// },
				pageSize: 10, // display 20 records per page
				// serverPaging: true,
				// serverFiltering: true,
				// serverSorting: true,
			},

			// layout definition
			layout: {
				scroll: false, // enable/disable datatable scroll both horizontal and vertical when needed.
				footer: false, // display/hide footer
			},

			// column sorting
			sortable: true,

			pagination: true,

			search: {
				input: $('#kt_datatable_search_query_published'),
				delay: 400,
				key: 'generalSearch'
			},

			// columns definition
			columns: [
				{
					field: 'id',
					title: '#',
					sortable: 'dsc',
					width: 40,
					type: 'number',
					selector: false,
					textAlign: 'center',
				}, {
					field: 'Conferences',
					title: 'Conferences',
					width: 800,
					autoHide: false,
					template: function(data) {
						var user_img = 'background-image:url(\'my_assets/logos/' + data.icon + '\')';

						var output = '';

						output = '<div class="d-flex align-items-center">\
							<div class="symbol symbol-60 flex-shrink-0">\
								<div class="symbol-label" style="' + user_img + '"></div>\
							</div>\
							<div class="ml-2">\
								<div class="text-dark-75 font-weight-bold line-height-lg font-size-lg"> <a href="'+ data.event_url + '">' + data.event + '</a></div>\
								<a href="#" class="font-size-sm text-dark-50 text-hover-primary">' +
								data.place + '</a>\
							</div>\
						</div>';



						return output;
					},
				}, {
					field: 'Date',
					title: 'Date',
					width: 150,
					template: function(data) {
                    	return data.date;
                	},
				}, {
					field: 'Status',
					title: 'Status',
					width: 150,
					// callback function support for column rendering
					template: function(row) {
						var status = {
							0: {'title': 'Participant', 'state': 'secondary'},
							1: {'title': 'Contributed Poster', 'state': 'success'},
							2: {'title': 'Invited Talk', 'state': 'danger'},
						};
						return '<span class="label font-weight-bold label-lg label-' + status[row.status].state + ' label-dot mr-2"></span><span class="font-weight-bold text-' + status[row.status].state + '">' +
								status[row.status].title + '</span>';
					},
				}
				],

		});

		$('#kt_datatable_search_status').on('change', function() {
			datatable.search($(this).val().toLowerCase(), 'Status');
		});

		$('#kt_datatable_search_type').on('change', function() {
			datatable.search($(this).val().toLowerCase(), 'Type');
		});

		$('#kt_datatable_search_status, #kt_datatable_search_type').selectpicker();

	};

	return {
		// public functions
		init: function() {
			demo();
		},
	};
}();


jQuery(document).ready(function() {
	KTDatatableColumnRenderingDemo.init();
});
